export default "__VITE_ASSET__Bjsmzu2Q__"